module.exports = {
    Cache: require('./cache'),
    MemoryStore: require('./memoryStore')
};